function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "postcard",
  transform: "translate(0.000000, -3.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 3.000000)"
}, React.createElement("path", {
  d: "M0,22 L28,22 L28,0 L0,0 L0,22 Z M2,20 L2,2 L26,2 L26,20 L2,20 Z",
  id: "Stroke-1"
}), React.createElement("path", {
  d: "M13.9526843,11.690712 C14.564066,11.206009 15.1291432,11 15.9963088,11 C17.1626341,11 17.7828986,11.3720443 18.7039221,12.2927845 C19.28336,12.8720443 19.4966852,13 19.9975392,13 C20.4990738,13 20.7127664,12.8718948 21.2928031,12.2922147 C22.2136202,11.3719637 22.833992,11 24,11 L24,13 C23.4992558,13 23.2858416,13.1279593 22.7061203,13.7073242 C21.7850034,14.6278748 21.1642605,15 19.9975392,15 C18.831214,15 18.2109494,14.6279557 17.289926,13.7072155 C16.710488,13.1279557 16.4971629,13 15.9963088,13 C15.4968181,13 15.2840618,13.1277717 14.7055875,13.7067803 C13.7855861,14.6276315 13.1658266,14.9998867 12.0005321,15 C11.1647685,15.6279212 10.1258247,16 9,16 C6.23866985,16 4,13.7616394 4,11 C4,8.2383606 6.23866985,6 9,6 C10.7862295,6 12.3537547,6.93662968 13.2380855,8.34565002 C13.2552939,8.32859838 13.2728327,8.31112479 13.2907213,8.2932197 C14.2108628,7.37222832 14.8306709,7 15.9963088,7 C17.1626341,7 17.7828986,7.37204428 18.7039221,8.29278449 C19.28336,8.87204428 19.4966852,9 19.9975392,9 C20.4990738,9 20.7127664,8.87189479 21.2928031,8.2922147 C22.2136202,7.37196372 22.833992,7 24,7 L24,9 C23.4992558,9 23.2858416,9.12795928 22.7061203,9.70732419 C21.7850034,10.6278748 21.1642605,11 19.9975392,11 C18.831214,11 18.2109494,10.6279557 17.289926,9.70721551 C16.710488,9.12795572 16.4971629,9 15.9963088,9 C15.4968181,9 15.2840618,9.12777168 14.7055875,9.7067803 C14.4390829,9.97353111 14.1977726,10.1942472 13.9610976,10.3732179 C13.9867728,10.5785342 14,10.7877212 14,11 C14,11.234355 13.9838785,11.4649417 13.9526843,11.690712 Z M12,11 C12,9.34299196 10.6568225,8 9,8 C7.34317751,8 6,9.34299196 6,11 C6,12.657008 7.34317751,14 9,14 C10.6568225,14 12,12.657008 12,11 Z",
  id: "Combined-Shape"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "22px",
    viewBox: "0 0 28 22",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/postcard.02628456.svg";
export { SvgComponent as ReactComponent };